"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataLoader = exports.Page = exports.Application = void 0;

var application_1 = require("./application");

Object.defineProperty(exports, "Application", {
  enumerable: true,
  get: function get() {
    return application_1.Application;
  }
});
Object.defineProperty(exports, "Page", {
  enumerable: true,
  get: function get() {
    return application_1.Page;
  }
});

var data_loader_1 = require("./data-loader");

Object.defineProperty(exports, "dataLoader", {
  enumerable: true,
  get: function get() {
    return data_loader_1.dataLoader;
  }
});
//# sourceMappingURL=index.js.map
